export default {
    updateEventLocations: function (eventId, locations, fetchTime){
        return {
            type: 'UPDATE_EVENT_LOCATIONS',
            eventId,
            locations,
            fetchTime
        };
    }
};
